const API_BASE_URL = '/api';

class CabangService {
  getToken() {
    return localStorage.getItem('auth_token');
  }

  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const token = this.getToken();
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
      },
      ...options,
    };
    const response = await fetch(url, config);
    const data = await response.json();
    if (!response.ok) {
      // Auto-logout jika token expired
      if (response.status === 401 && data.error && data.error.includes('Token expired')) {
        window.dispatchEvent(new CustomEvent('auth:token-expired'));
      }
      throw new Error(data.error || `HTTP error! status: ${response.status}`);
    }
    return data;
  }

  async getCabang() {
    return this.request('/cabang');
  }

  async getAllCabang() {
    return this.request('/cabang/all');
  }

  async createCabang(data) {
    return this.request('/cabang', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async updateCabang(id, data) {
    return this.request(`/cabang/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async deleteCabang(id) {
    return this.request(`/cabang/${id}`, {
      method: 'DELETE',
    });
  }
}

export const cabangService = new CabangService();
export default cabangService;
